import React from 'react'
// TODO JMA remove FormattedMessage
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import { BIcon, BLink, BText, BTitle } from '@prague-digi/ui-components'

import { ApiErrorInfo } from '../api/api'
import {
  ModalDialogConfiguration,
  ModalDialogSeverityEnum,
} from '../redux/reducers/modalDialog/model'
import { SmsVerify } from '../containers'
import ApiError from '../containers/ApiError/ApiError'
import BranchDocsInfo from '../containers/BranchDocsInfo/BranchDocsInfo'
import CacheAuthDialog from '../containers/CacheAuthDialog/CacheAuthDialog'
import InactivityDialog from '../components/InactivityDialog/InactivityDialog'
import InactivityDialogLogout from '../components/InactivityDialogLogout/InactivityDialogLogout'
import InsuranceQuestion from '../containers/InsuranceQuestion/InsuranceQuestion'
import LoanPreConfigurator from '../components/LoanPreConfigurator/LoanPreConfigurator'
import messages from '../i18n'
import OnlineVerification from '../components/OnlineVerification/OnlineVerification'
import pdfMultiple from '../assets/pdf-multiple.svg'
import ResetOrContinue from '../containers/ResetOrContinue/ResetOrContinue'
import DocumentInfoModal from '../components/DocumentInfoModal/DocumentInfoModal'
import idCardNumber2012 from '../assets/documentInfo/id-number-2012.jpg'
import idCardValidity2012 from '../assets/documentInfo/id-validity-2012.jpg'
import personalNumber2012 from '../assets/documentInfo/personal-number-2012.jpg'
import permanentAddress2012 from '../assets/documentInfo/permanent-address-2012.jpg'
import { MONETA_IM_LIST } from './url'
import { CZECH_PHONE_PREFIX, SUPPORT_PHONE, SUPPORT_PHONE2 } from './commonConstants'
import { PartialFields } from '../types'

type Config = PartialFields<ModalDialogConfiguration, 'show'>

export const POP_UPLOAD_FAILED = (callbackRetry: Function) => ({
  id: 'POP_UPLOAD_FAILED',
  image: <BIcon name="document" size="lg" />,
  title: <FormattedMessage {...messages.popUpload.modal.saveFail.title} />,
  content: <FormattedMessage {...messages.popUpload.modal.saveFail.content} />,
  centerContent: true,
  secondButton: {
    text: messages.popUpload.modal.saveFail.closeButton,
  },
  closeButton: {
    onClick: callbackRetry,
    text: messages.popUpload.modal.saveFail.buttonRetry,
  },
  preferredWidth: '700px',
})

export const POP_WRONG_FILE: Config = {
  id: 'POP_WRONG_FILE',
  image: <BIcon name="document" size="lg" />,
  title: <FormattedMessage {...messages.popUpload.modal.wrongFile.title} />,
  content: <FormattedMessage {...messages.popUpload.modal.wrongFile.content} />,
  centerContent: true,
  closeButton: {
    text: messages.popUpload.modal.wrongFile.closeButton,
  },
  preferredWidth: '700px',
}

interface PopFilesCountWarning {
  fileCount: number
  goNext: Function
}

export const POP_FILES_COUNT = ({ fileCount, goNext }: PopFilesCountWarning) => ({
  id: 'POP_FILES_COUNT',
  image: <img alt="pdf icon" src={pdfMultiple} />,
  title: <FormattedMessage {...messages.popUpload.modal.filesCount.title} values={{ fileCount }} />,
  content: (
    <>
      <BText>
        <FormattedMessage {...messages.popUpload.modal.filesCount.content} />
      </BText>
      <BTitle type="h4">
        <FormattedMessage {...messages.popUpload.modal.filesCount.lastQuestion} />
      </BTitle>
    </>
  ),
  centerContent: true,
  secondButton: {
    text: messages.popUpload.modal.filesCount.secondButton,
  },
  closeButton: {
    text: messages.popUpload.modal.filesCount.closeButton,
    onClick: goNext,
  },
  preferredWidth: '700px',
})

export const LOAN_DATA_MISSING: Config = {
  id: 'LOAN_DATA_MISSING',
  content: <LoanPreConfigurator isMissingDataModal isModal />,
  noFooter: true,
  preferredWidth: '700px',
}

export const SHOW_NEEDED_DOCS: Config = {
  id: 'SHOW_NEEDED_DOCS',
  content: <BranchDocsInfo />,
  noFooter: true,
  preferredWidth: '700px',
}

export const SHOW_INACTIVITY: Config = {
  id: 'SHOW_INACTIVITY',
  severity: ModalDialogSeverityEnum.Inactivity,
  content: <InactivityDialog />,
  noFooter: true,
  preferredWidth: '700px',
}

export const SHOW_INACTIVITY_LOGOUT: Config = {
  id: 'SHOW_INACTIVITY_LOGOUT',
  severity: ModalDialogSeverityEnum.Inactivity,
  content: <InactivityDialogLogout />,
  noFooter: true,
  preferredWidth: '700px',
}

interface OtherCostOfLivingLimit {
  amount: string
  callback: Function
}

export const OTHER_COST_OF_LIVING_MODAL = ({ amount, callback }: OtherCostOfLivingLimit) => ({
  closeButton: { onClick: callback, text: messages.common.continue },
  content: <FormattedHTMLMessage {...messages.financeExpenses.modal.content} />,
  id: 'OTHER_COST_OF_LIVING_LIMIT',
  preferredWidth: '700px',
  secondButton: { text: messages.financeExpenses.modal.secondaryButton },
  title: <FormattedHTMLMessage {...messages.financeExpenses.modal.title} values={{ amount }} />,
})

export const INSURANCE_QUESTION = (
  callBackWithIns: Function,
  callBackWithoutIns: Function,
  amount: number
) => ({
  id: 'INSURANCE_QUESTION',
  content: <InsuranceQuestion amount={amount} />,
  noFooter: false,
  preferredWidth: '700px',
  closeButton: {
    onClick: callBackWithIns,
    text: messages.InsuranceQuestion.withoutInsurance,
  },
  secondButton: {
    onClick: callBackWithoutIns,
    text: messages.InsuranceQuestion.withInsurance,
  },
})

export const EXIT_14_DAYS = (
  callBackWithIns: Function,
  callBackWithoutIns: Function,
  amount: number
): any => ({
  id: 'EXIT_14_DAYS',
  content: <InsuranceQuestion amount={amount} />,
  noFooter: false,
  preferredWidth: '700px',
  closeButton: {
    onClick: callBackWithIns,
    text: messages.InsuranceQuestion.withoutInsurance,
  },
  secondButton: {
    onClick: callBackWithoutIns,
    text: messages.InsuranceQuestion.withInsurance,
  },
})

interface ApiErrorInterface {
  errorInfo: ApiErrorInfo
  onRetry?: Function
  beforeScoring?: boolean
}

export const API_ERROR = ({ errorInfo, onRetry, beforeScoring }: ApiErrorInterface) => ({
  id: 'API_ERROR',
  noFooter: true,
  preferredWidth: '700px',
  severity: ModalDialogSeverityEnum.Warning,
  content: (
    <ApiError
      id="API_ERROR"
      errorInfo={errorInfo}
      onRetry={onRetry}
      beforeScoring={beforeScoring}
    />
  ),
})

export const SMS_VERIFY: Config = {
  id: 'SMS_VERIFY',
  noFooter: true,
  content: <SmsVerify />,
  preferredWidth: '700px',
}

export const RESET_CONTINUE_DIALOG: Config = {
  id: 'RESET_CONTINUE_DIALOG',
  content: <ResetOrContinue />,
  noFooter: true,
  preferredWidth: '700px',
}

export const MAKE_CACHE_AUTH_DIALOG = (maskedPhone: string) => ({
  id: 'CACHE_AUTH',
  content: <CacheAuthDialog phoneNumber={maskedPhone} />,
  noFooter: true,
  preferredWidth: '700px',
})

export const CLIENT_INFO_MARKETING: Config = {
  id: 'CLIENT_INFO_MARKETING',
  title: <FormattedMessage {...messages.clientInfo.marketing.modal.title} />,
  content: <FormattedMessage {...messages.clientInfo.marketing.modal.text} />,
  centerContent: true,
  closeButton: {
    text: messages.common.back,
  },
}

export const CLIENT_INFO_ENCRYPTION: Config = {
  id: 'CLIENT_INFO_ENCRYPTION',
  title: <FormattedMessage {...messages.clientInfo.encryption.modal.title} />,
  content: <FormattedMessage {...messages.clientInfo.encryption.modal.text} />,
  centerContent: true,
  closeButton: {
    text: messages.common.back,
  },
}

export const CLIENT_INFO_IM: Config = {
  id: 'CLIENT_INFO_IM',
  title: <FormattedMessage {...messages.clientInfo.imConsent.modal.title} />,
  content: (
    <div>
      <FormattedMessage
        {...messages.clientInfo.imConsent.modal.text1}
        values={{
          link: (
            <BLink href={MONETA_IM_LIST} target="_blank">
              <FormattedMessage {...messages.clientInfo.imConsent.modal.link} />
            </BLink>
          ),
        }}
      />

      <br />
      <br />
      <FormattedMessage
        {...messages.clientInfo.imConsent.modal.text2}
        values={{
          phone1: (
            <span>
              {CZECH_PHONE_PREFIX}&nbsp;{SUPPORT_PHONE}
            </span>
          ),
          phone2: (
            <span>
              {CZECH_PHONE_PREFIX}&nbsp;{SUPPORT_PHONE2}
            </span>
          ),
        }}
      />
    </div>
  ),
  centerContent: true,
  closeButton: {
    text: messages.common.back,
  },
}

export const ONLINE_VERIFICATION: Config = {
  content: <OnlineVerification />,
  id: 'ONLINE_VERIFICATION',
  preferredWidth: '700px',
  title: <FormattedMessage {...messages.identity.modal.title} />,
}

export const PERMANENT_ADDRESS_HINT: Config = {
  id: 'PERMANENT_ADDRESS_HINT',
  title: <FormattedMessage {...messages.documentInfoModal.permanentAddress.title} />,
  content: (
    <DocumentInfoModal
      img2012={permanentAddress2012}
      text={messages.documentInfoModal.permanentAddress.text}
    />
  ),
}

export const PERSONAL_NUMBER_HINT: Config = {
  id: 'PERSONAL_NUMBER_HINT',
  title: <FormattedMessage {...messages.documentInfoModal.personalNumber.title} />,
  content: (
    <DocumentInfoModal
      img2012={personalNumber2012}
      text={messages.documentInfoModal.personalNumber.text}
    />
  ),
}

export const ID_CARD_NUMBER_HINT: Config = {
  id: 'ID_CARD_NUMBER_HINT',
  title: <FormattedMessage {...messages.documentInfoModal.idCardNumber.title} />,
  content: (
    <DocumentInfoModal
      img2012={idCardNumber2012}
      text={messages.documentInfoModal.idCardNumber.text}
    />
  ),
}

export const ID_CARD_VALIDITY_HINT: Config = {
  id: 'ID_CARD_VALIDITY_HINT',
  title: <FormattedMessage {...messages.documentInfoModal.idCardValidity.title} />,
  content: (
    <DocumentInfoModal
      img2012={idCardValidity2012}
      text={messages.documentInfoModal.idCardValidity.text}
    />
  ),
}

export const ENTER_PERSONAL_DATA: Config = {
  content: <FormattedMessage {...messages.personalDataModal.text} />,
  id: 'ENTER_PERSONAL_DATA',
  preferredWidth: '720px',
  title: <FormattedMessage {...messages.personalDataModal.title} />,
}

export const TELCO_SCORING_CONSENT: Config = {
  closeButton: {
    text: messages.common.back,
  },
  centerContent: true,
  content: (
    <div style={{ textAlign: 'left' }}>
      <FormattedHTMLMessage {...messages.TelcoScoringConsentModal.text} />
    </div>
  ),
  id: 'TELCO_SCORING_CONSENT',
  title: <FormattedMessage {...messages.TelcoScoringConsentModal.title} />,
}

export const OUIBOUNCE_MODAL: Config = {
  title: <FormattedMessage {...messages.basicLayout.ouibounceModal.title} />,
  id: 'OUIBOUNCE_MODAL',
  content: <FormattedMessage {...messages.basicLayout.ouibounceModal.text} />,
  closeButton: {
    text: messages.common.iUnderstand,
  },
}
